import React from 'react';
import { Table, Button, Popconfirm, Row, Col, Space } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

export default function AvalaraSettingsList({ setting, onEdit, markActive, onAdd, loading }) {
  const columns = [
    { title: 'Environment', dataIndex: 'environment', key: 'environment' },
    { title: 'Avalara API Endpoint', dataIndex: 'endpoint', key: 'endpoint' },

    { title: 'Avalara Username', dataIndex: 'username', key: 'username' },
    { title: 'company_code', dataIndex: 'company_code', key: 'company_code' },
    {
      title: 'Actions', key: 'actions',
      render: (_, record) => (
        <Space gap="small" wrap>
          <Button onClick={() => onEdit(record)}>Edit</Button>
          {
            !record.is_active && (
              <Popconfirm title={`Are you sure ('Activate)?`} onConfirm={() => markActive(record.id)}>
                <Button>Activate</Button>
              </Popconfirm>
            )
          }
        </Space>
      )
    }
  ];

  return (
    <>
      <Row justify="end" gutter={8}>
        <Col>
          <Button type="primary" onClick={onAdd} icon={<PlusOutlined />} className='mb-16'>
            ADD AVALARA SETTINGS
          </Button>
        </Col>
      </Row>
      <Table
        dataSource={setting}
        columns={columns}
        rowKey="id"
        loading={loading}
        scroll={{ x: 'max-content' }}
        size="small"
        pagination={false}
      />
    </>
  );
}
